/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestRunSummary } from '../../models/test-run-summary';

export interface GetnotificationsTestRunUpdatedSchema$Params {
}

export function getnotificationsTestRunUpdatedSchema(http: HttpClient, rootUrl: string, params?: GetnotificationsTestRunUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<TestRunSummary>> {
  const rb = new RequestBuilder(rootUrl, getnotificationsTestRunUpdatedSchema.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TestRunSummary>;
    })
  );
}

getnotificationsTestRunUpdatedSchema.PATH = '/api/hubs/notifications/TestRunUpdated';
